/** Webapp 主题入口：颜色 / 图标来自 AgentConfig.theme */
import {
  applyAgentThemeToRoot,
  buildAgentTheme,
  DEFAULT_PRIMARY_COLOR,
  type ThemeVariant,
} from '@beidou/agent-protocol';

export { DEFAULT_PRIMARY_COLOR as CYAN_BEAM_PRIMARY, buildAgentTheme, type ThemeVariant };

/** @deprecated 使用 buildAgentTheme(primary_color) */
export const CYAN_BEAM = buildAgentTheme(DEFAULT_PRIMARY_COLOR, 'default');
export const CYAN_BEAM_LITE = buildAgentTheme(DEFAULT_PRIMARY_COLOR, 'embed-lite');

export function applyCyanBeamTheme(
  root: HTMLElement = document.documentElement,
  variant: ThemeVariant = 'default',
  primaryColor?: string | null,
  backgroundColor?: string | null,
  iconId?: string | null,
): void {
  applyAgentThemeToRoot(root, primaryColor, variant, backgroundColor, false, iconId);
}

export function resolveThemeVariant(options: {
  config?: { theme?: { variant?: string } } | null;
  themeMode?: string;
  embedded?: boolean;
}): ThemeVariant {
  const { config, themeMode, embedded } = options;
  if (themeMode === 'embed-lite' || themeMode === 'default') {
    return themeMode;
  }
  if (config?.theme?.variant === 'embed-lite') {
    return 'embed-lite';
  }
  if (embedded) {
    return 'embed-lite';
  }
  return 'default';
}

export function applyThemeFromConfig(
  root: HTMLElement,
  config?: {
    theme?: {
      primary_color?: string;
      background_color?: string;
      icon?: string;
      variant?: string;
      show_frame_border?: boolean;
    };
  } | null,
  options?: { themeMode?: string; embedded?: boolean },
): ReturnType<typeof applyAgentThemeToRoot> {
  const variant = resolveThemeVariant({
    config,
    themeMode: options?.themeMode,
    embedded: options?.embedded,
  });
  return applyAgentThemeToRoot(
    root,
    config?.theme?.primary_color,
    variant,
    config?.theme?.background_color,
    Boolean(config?.theme?.show_frame_border),
    config?.theme?.icon,
  );
}
